var Status;
(function (Status) {
    Status["Success"] = "Success";
    Status["Failure"] = "Failure";
    Status["Loading"] = "Loading";
    Status["NotAsked"] = "NotAsked";
})(Status || (Status = {}));
export var notAsked = {
    status: Status.NotAsked,
};
export var loading = {
    status: Status.Loading,
};
export function success(data) {
    return {
        status: Status.Success,
        data: data,
    };
}
export function failure(error) {
    return {
        status: Status.Failure,
        error: error,
    };
}
export function isNotAsked(remoteData) {
    return remoteData.status === Status.NotAsked;
}
export function isLoading(remoteData) {
    return remoteData.status === Status.Loading;
}
export function isSuccess(remoteData) {
    return remoteData.status === Status.Success;
}
export function isSuccessAll(responses) {
    return responses.every(isSuccess);
}
export function isFailure(remoteData) {
    return remoteData.status === Status.Failure;
}
export function isFailureAny(responses) {
    return responses.some(isFailure);
}
export function isLoadingAny(responses) {
    return responses.some(isLoading);
}
export function isNotAskedAny(responses) {
    return responses.some(isNotAsked);
}
//# sourceMappingURL=remoteData.js.map